<template>
    <div class="modal-container-cont">
        <div class="overlay" @click="closeModal()"></div>
        <div class="modal-container">
            <div class="modal-form-container">
                <div class="title-box">
                    <h2>{{ getString('escolha_um_grupo') }}</h2>
                </div>
            </div>

            <div class="option-groups">
                <div v-for="(group, key) in groupsData" :key="'select-group-' + key" class="select-mutex-option" @click="pickMutexGroup(group, $event)">
                    <div class="container-input">
                        <input class="styled-input"
                            :id="'select-group-' + key"
                            type="checkbox"
                            @change="pickMutexGroup(group, $event)">
                        <label class="checkmark radio" :for="'select-group-' + key"></label >
                    </div>
                    <label :for="'select-group-' + key">
                        <span v-text="group.name"></span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
// import Util from '@/assets/libs/util'

export default {
    name: 'SelectMutexModalGom',
    props: ['groupsData', 'calledOnMounted', 'oldProductGroup'],
    data () {
        return {

        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        closeModal: function () {
            this.$emit('closeSelectMutexModal')
        },
        pickMutexGroup: function (group, event) {
            this.$emit('pickMutexGroup', group.index, group.mutexKey, this.calledOnMounted, this.oldProductGroup)
            this.closeModal()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    .modal-container-cont{
        .full;
        display: block;
        bottom: 0;
        z-index: 5;
    }

    .modal-container {
        z-index: 6;
        position: absolute;
        pointer-events: auto;
        left: 0;
        right: 0;
        top: 50%;
        margin: auto 70px;
        background: @white;
        border-radius: 10px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        transform: translate(0%, -50%);
        min-height: 300px;

        .modal-form-container {
            position: relative;
            overflow: hidden auto;

            .title-box {
                // background-color: @primary-color;
                height: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 10px 10px 0px 0px;
                border: solid 1px rgba(0, 0, 0, 0.1);

                h2 {
                    color: @black;
                    margin: auto;
                    font-size: 35px;
                }
            }
        }

        .option-groups {
            // min-height: 200px;
            // display: grid;
            // grid-template-columns: 50% 50%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-around;
            align-items: center;
            padding: 35px 10px;

            .select-mutex-option {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 10px;
                width: 45%;
                // border: solid 1px black;
                border-radius: 10px;
                justify-content: center;
                box-shadow: rgba(0, 0, 0, 0.3) 0 5px 15px;
                .container-input {
                    display: none;
                }
                label {
                    font-size: 1.8rem;
                    padding: 25px;
                    text-align: center;
                }
            }
        }
    }

    .overlay{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        .modal-container {
            margin: auto 50px;

            .modal-form-container {
                .title-box {
                    height: 100px;
                    h2 {
                        font-size: 35px;
                    }
                }
            }
            .option-groups {
                .select-mutex-option {
                    // margin: 60px 20px;
                   label {
                        font-size: 22px;
                   }
                }
            }
        }
    }
    @media (max-width: 698px) { // Gertec SK210
        .modal-container {
            margin: auto 30px;
            min-height: 250px;
            .modal-form-container {
                .title-box {
                    height: 70px;
                    h2 {
                        font-size: 25px;
                    }
                }
            }
            .option-groups {
                .select-mutex-option {
                    // margin: 60px 20px;
                    margin: 0;
                   label {
                        font-size: 18px;
                   }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/SelectMutexModalGom.vue